import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Paper from "@mui/material/Paper";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { isMobile, isChrome } from "react-device-detect";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Typography } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FirstLoginDialog({ startShowClip }) {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    const installApp = JSON.parse(localStorage.getItem("installApp"));
    let DonthowFristLoad = JSON.parse(localStorage.getItem("DonthowFristLoad"));
    if (DonthowFristLoad) setOpen(false);
    else {
      if (installApp) setOpen(true);
    }
  }, []);
  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        // onClose={handleClose}
        aria-describedby="مشاهده فیلم با دو زیرنویس همزمان و یادگیری زبان"
      >
        <>
          <DialogTitle>شروع یادگیری زبان با فیلم و سریال</DialogTitle>
          <DialogContent>
            {/* <Typography sx={{ color: "green", fontWeight: "bold" }}>
              لطفا ابتدا برای آشنایی با سایت بر روی دکمه شروع کلیک کنید
            </Typography> */}
          </DialogContent>
          <DialogActions sx={{ alignSelf: "center" }}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  onChange={(e) => {
                    localStorage.setItem(
                      "DonthowFristLoad",
                      JSON.stringify(e.target.checked)
                    );
                  }}
                />
              }
              label={
                <Typography variant="body2" color="textSecondary">
                  دیگر نشان داده نشود
                </Typography>
              }
            />
            <Button color="error" onClick={handleClose}>
              بستن
            </Button>
            <Button
              variant="contained"
              color="success"
              sx={{ px: 6 }}
              onClick={() => {
                startShowClip();
                handleClose();
              }}
            >
              آشنایی با اوملنگ
            </Button>
          </DialogActions>
        </>
      </Dialog>
    </React.Fragment>
  );
}
